import { jsx } from 'react/jsx-runtime';
import { useLayoutEffect } from '@radix-ui/react-use-layout-effect';
import { useRef } from 'react';
import { createPortal } from 'react-dom';

function Portal({ containerRef, children }) {
  const ref = useRef(containerRef?.current ?? null);
  useLayoutEffect(() => {
    ref.current = containerRef?.current ?? document.createElement("div");
    if (ref.current !== null) {
      document.body.appendChild(ref.current);
    }
    return () => {
      ref.current !== null && document.body.removeChild(ref.current);
    };
  }, [containerRef]);
  if (ref.current === null) {
    return null;
  }
  return createPortal(/* @__PURE__ */ jsx("div", { children }), ref.current);
}

export { Portal as default };
//# sourceMappingURL=Portal.mjs.map
